import { useMutation } from '@tanstack/react-query'
import { integrationOptionValues } from '../../v3/integrationOptionValues'
import { type IntegrationOptionValuesParams } from './useIntegrationOptionValues'

type CreateParams = IntegrationOptionValuesParams & { name: string }

/**
 * Invalidate `globalQueryKeys.integrationOptionValues` in the call site's
 * `onSuccess`.
 */
export function useCreateIntegrationOptionValue() {
  return useMutation({
    mutationFn: ({ workspaceUuid, provider, option, name }: CreateParams) =>
      integrationOptionValues.create({
        requestBody: {
          data: {
            type: 'integration_option_value',
            attributes: { name, option, provider },
            relationships: {
              workspace: { data: { id: workspaceUuid, type: 'workspace' } },
            },
          },
        },
      }),
  })
}
